import React, { ChangeEvent } from 'react';
import Form, { FormTemplate, FormUtils } from '../../../components/molecules/Form';
import IForm from '../../../types/IForm';
import FormsRow from '../../../components/molecules/Form/components/FormsRow/FormsRow';
import FormSelect, { optionsProcessor } from '../../../components/molecules/Form/components/FormSelect/FormSelect';
import LiveRegion from '../../../components/atoms/LiveRegion/LiveRegion';
import { InteractionStatus } from '../../../types/InteractionStatus';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { FormSubmitButton } from '../../../components/molecules/Form/components/FormSubmitButton/FormSubmitButton';

type ConnectedUsersAddFormProps = {
  form: IForm;
  onSuccess(): void;
};

export function ConnectedUsersEditForm({ form, onSuccess }: ConnectedUsersAddFormProps) {
  const { t } = useSonTranslation('ConnectedUsers');
  const id = 'connected-users-edit-form';

  const statusMessage = {
    [InteractionStatus.SUCCESS]: FormUtils.createStatusMessage(t('editForm.status.success')),
    [InteractionStatus.SENDING]: FormUtils.createStatusMessage(t('editForm.status.sending')),
    [InteractionStatus.FAIL]: FormUtils.createStatusMessage(t('editForm.status.fail')),
  };

  const renderTemplate = ({ inputs, getStatus, onChange, hiddenFields, hasChanges, status }: any) => {
    return (
      <>
        {hiddenFields}
        <FormsRow>
          <FormSelect
            id={`${inputs.roleId.name}-${id}`}
            name={inputs.roleId.name}
            required
            labelTitle={t(`addForm.input.role`)}
            value={inputs.roleId.value}
            options={optionsProcessor(inputs.roleId.name, inputs.roleId.options)}
            onChange={(event: ChangeEvent<HTMLInputElement>) => onChange(inputs.roleId.name, event.target.value) as any}
          />
        </FormsRow>
        <FormSubmitButton
          buttonLabel={t('editForm.submit')}
          enabled={hasChanges() && status === InteractionStatus.NONE}
        />
        <LiveRegion htmlTag="div" invisible={false}>
          {getStatus(statusMessage)}
        </LiveRegion>
      </>
    );
  };

  return (
    <Form id={id} model={form} onSuccess={onSuccess}>
      <FormTemplate>{renderTemplate}</FormTemplate>
    </Form>
  );
}
